/**
 * Fly a clone of `sourceImg` to the cart icon target.
 * The cart icon must have id="cart-icon-target".
 */
export const flyToCart = (sourceImg) => {
  if (!sourceImg) return;
  const target = document.getElementById("cart-icon-target");
  if (!target) return;

  const start = sourceImg.getBoundingClientRect();
  const end = target.getBoundingClientRect();

  const clone = document.createElement("img");
  clone.src = sourceImg.src;
  clone.alt = "";
  clone.className = "fly-clone";
  clone.style.left = `${start.left}px`;
  clone.style.top = `${start.top}px`;
  clone.style.width = `${start.width}px`;
  clone.style.height = `${start.height}px`;
  document.body.appendChild(clone);

  const sx = start.left + start.width / 2;
  const sy = start.top + start.height / 2;
  const ex = end.left + end.width / 2;
  const ey = end.top + end.height / 2;
  const dx = ex - sx;
  const dy = ey - sy;

  // Slight arc via a peak keyframe
  const peakDx = dx * 0.45;
  const peakDy = dy * 0.15 - 60;

  const anim = clone.animate(
    [
      { transform: "translate(0, 0) scale(1) rotate(0deg)", opacity: 1, borderRadius: "20px" },
      {
        transform: `translate(${peakDx}px, ${peakDy}px) scale(0.55) rotate(-8deg)`,
        opacity: 0.95,
        borderRadius: "30px",
        offset: 0.55,
      },
      {
        transform: `translate(${dx}px, ${dy}px) scale(0.12) rotate(8deg)`,
        opacity: 0.35,
        borderRadius: "9999px",
      },
    ],
    { duration: 780, easing: "cubic-bezier(0.55, 0, 0.4, 1)" },
  );

  anim.onfinish = () => {
    clone.remove();
    target.classList.remove("cart-receive");
    // trigger reflow to re-run animation
    void target.offsetWidth;
    target.classList.add("cart-receive");
    setTimeout(() => target.classList.remove("cart-receive"), 700);
  };
};
